import { useRequest } from 'umi';
import React, { useEffect, useState } from 'react';
import styles from '../css/dynamicCSS.less';
import { getDynamicPage } from '@/utils/requests/camp/requests_dynamic';
import { DynamicType } from '@/types/camp/dynamic/dynamicType';
import { Modal } from '@digit-fe/digit-component';
import DynamicTabs from '@/pages/camp/components/dynamic/dynamicTabs';
import MoreLink from '@/components/moreLink';
import wenhaoPng from '@/static/images/wenhao.png';
import DynamicItem from '@/pages/camp/components/dynamic/dynamicItem';
import { CloseOutlined } from '@ant-design/icons';

interface props {
  selected: number;
  campId: string;
  startText?: string;
  batchId?: string;
  setTabKey?: (tabKey: string) => void;
  isFirst?: boolean;
  tabKey?: string;
}
const DynamiCenrollStudent: React.FC<props> = (props) => {
  const [pageData, setPageData] = React.useState<DynamicType[]>([]);
  const [hash, setHash] = React.useState<number>();
  const [total, setTotal] = React.useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);

  // 获取动态分页
  const { run: getDynamicPageRequest } = useRequest(
    () => {
      const params = {
        campId: props.campId || '',
        batchId: props.batchId || '',
        selected: props.selected,
        current: 1,
        size: 3,
      };
      return getDynamicPage(params);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setPageData(res.records);
        setTotal(res.total);
        if (props && typeof props.setTabKey === 'function') {
          if (props.isFirst && props.selected === 1) {
            props.setTabKey(res.total === 0 ? '2' : '1');
          }
        }
      },
    },
  );
  useEffect(() => {
    getDynamicPageRequest();
    if (hash) {
      setPageData([]);
    }
  }, [props.campId, hash]);

  return (
    <>
      <div className={styles.dynamic_box_main}>
        {pageData.length > 0 ? (
          pageData.map((item, index) => (
            <DynamicItem key={index} item={item} index={index} setHash={setHash} />
          ))
        ) : (
          <div className="flex_4_1" style={{ padding: '60px 0 100px' }}>
            <img src={wenhaoPng} width={200} height={200} />
            <div className="col808">未找到相关动态</div>
          </div>
        )}
        <div style={{ textAlign: 'center', paddingTop: 14 }}>
          <div style={{ width: 100, margin: '0 auto' }}>
            {total > 3 && (
              <span onClick={() => setOpen(true)}>
                <MoreLink
                  url="javascript:;"
                  text="查看更多"
                  css="f14 col008 hover008"
                  iconCss="f14"
                />
              </span>
            )}
          </div>
        </div>
      </div>
      <Modal
        wrapClassName={styles.modal_dynamic_details}
        open={open}
        // style={{ height: '90vh' }}
        destroyOnClose={true}
        centered
        width={1200}
        onOk={() => {}}
        onCancel={() => {
          setOpen(false);
        }}
        footer={null}
        closable={false}
        title={
          <div className={styles.modal_dynamic_details_header}>
            <CloseOutlined
              onClick={() => {
                setOpen(false);
              }}
            />
          </div>
        }
      >
        <DynamicTabs type={0} campId={props.campId} newTabKey={props.tabKey} />
      </Modal>
    </>
  );
};
export default DynamiCenrollStudent;
